"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

exports.initialState = {
  hidden: document.hidden,
  visibilityState: document.visibilityState
};

var useVisible = function useVisible() {
  var _react_1$useState = react_1.useState(exports.initialState),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  var onVisibilityChangeEvent = function onVisibilityChangeEvent(event) {
    setState({
      hidden: document.hidden,
      visibilityState: document.visibilityState
    });
  };

  react_1.useEffect(function () {
    document.addEventListener('visibilitychange', onVisibilityChangeEvent);
    return function () {
      document.removeEventListener('visibilitychange', onVisibilityChangeEvent);
    };
  }, []);
  return state;
};

exports.default = useVisible;